import React from "react";
import {
    Box,
    Grid,
    Card,
    CardMedia,
    CardContent,
    Typography
} from "@mui/material";

function MalaysiaLocation() {
    const location = {
        id: "malaysia",
        title: "Malaysia",
        image: "/images/twintower.jpg",
        address: (
            <>
                Tower 3, 03-10-03, UOA Business Park <br />
                No.1, Jalan Pengaturcar, U1/51A, <br />
                Section U1, 40150 Shah Alam, <br />
                Selangor Darul Ehsan, Malaysia.
            </>
        ),
        tel: "603 50310635",
        email: "info@vensyx.com",
        website: "www.vensyx.com"
    };

    return (
        <Box sx={{ p: 3 }}>
            <Grid container justifyContent="center">
                <Grid item xs={12} sm={8} md={6}>
                    <Card
                        sx={{
                            height: "100%",
                            borderRadius: 2,
                            boxShadow: 3,
                            bgcolor: "background.paper"
                        }}
                    >
                        <CardMedia
                            component="img"
                            height="250"
                            image={location.image}
                            alt={location.title}
                            sx={{ borderRadius: "10px 10px 0 0" }}
                        />
                        <CardContent sx={{ textAlign: "center" }}>
                            <Typography variant="h5" gutterBottom>
                                {location.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph>
                                {location.address}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Tel: {location.tel}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Email: {location.email}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Website: {location.website}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}

export default MalaysiaLocation;
